import {useReadMoreIconAndLabels} from "./useReadMoreIconAndLabels";

export const useReadMoreIcon = ({icon}) => {
    const iconAndLabels = useReadMoreIconAndLabels()

    return iconAndLabels[icon]?.icon
}